export enum ProgramsAllOrderingEnum {
  Name = 'Name',
  ProgramYear = 'ProgramYear',
}
